module.exports = __webpack_public_path__ + "img/toplogo.6de538ac.png";